import React from "react";
import styles from "./index.module.scss";
import { Modal } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import PrescriptionDisplayComponent from "../PrescriptionDisplayComponent/PrescriptionDisplayComponent";

function PrescriptionDisplayModal({ isOpen = true, onClose ,wholeData,appointmentHistoryRedux,clientDetails}) {
  console.debug('Display',appointmentHistoryRedux?.[0]);
  return (
    <Modal
      className={styles.display_priscription_modal_container}
      footer={false}
      closeIcon={<CloseOutlined />}
      open={isOpen}
      onCancel={() => {
        onClose && onClose(false);
      }}
      backdrop="static"
      maskClosable={false}
    >
      <PrescriptionDisplayComponent wholeData={wholeData} appointmentHistoryRedux={appointmentHistoryRedux} clientDetails={clientDetails}/>
    </Modal>
  );
}

export default PrescriptionDisplayModal;
